(function ($) {
    $(function () {
  
      // $('.clickwrapper > .col-6').click(function(){
      //   $('.active').not(this).removeClass('active');
      //   $(this).toggleClass('active');
      // })


      
      $('.clickwrapper > .col-6.link1').click(function(){
        $('.clickwrapper .col-12 .hovercontent1').addClass('active');
        $('.clickwrapper .col-12 .hovercontent2').removeClass('active');
        $('.clickwrapper .col-12 .hovercontent3').removeClass('active');
        $('.clickwrapper .col-12 .hovercontent4').removeClass('active');
      });
      
      $('.clickwrapper > .col-6.link2').click(function(){
        $('.clickwrapper .col-12 .hovercontent2').addClass('active');
        $('.clickwrapper .col-12 .hovercontent1').removeClass('active');
        $('.clickwrapper .col-12 .hovercontent3').removeClass('active');
        $('.clickwrapper .col-12 .hovercontent4').removeClass('active');
      });

      $('.clickwrapper > .col-6.link3').click(function(){
        $('.clickwrapper .col-12 .hovercontent3').addClass('active');
        $('.clickwrapper .col-12 .hovercontent1').removeClass('active');
        $('.clickwrapper .col-12 .hovercontent2').removeClass('active');
        $('.clickwrapper .col-12 .hovercontent4').removeClass('active');
      });

      $('.clickwrapper > .col-6.link4').click(function(){
        $('.clickwrapper .col-12 .hovercontent4').addClass('active');
        $('.clickwrapper .col-12 .hovercontent1').removeClass('active');
        $('.clickwrapper .col-12 .hovercontent2').removeClass('active');
        $('.clickwrapper .col-12 .hovercontent3').removeClass('active');
      });

      
      $(".hamburger_menu_btn").on("click", function () {
          $('#g4JRTtrNnT').toggle(); // Toggles visibility
      });

    });
    // $(document).ready(function () {
      
    //   // Show it after 5 seconds (5000 milliseconds)
    //   setTimeout(function () {
    //     $('#banner-wrapper').fadeIn(); // You can use .show() instead if you don't want a fade effect
    //   }, 5000);
    // });
  
})(jQuery);

// window.addEventListener('load', function () {
//     setTimeout(function () {
//       var banner = document.getElementById('banner-wrapper');
//       if (banner) {
//         banner.style.cssText = 'display: block !important;';
//       }
//     }, 8000);
// });